import tokens from '~/public/img/tokens';
import { getAddress } from 'ethers';

export enum Tokens {
  pearl = 'pearl',
  doubloon = 'doubloon',
  gold = 'gold',
  goldOre = 'goldOre',
  coal = 'coal',
  iron = 'iron',
  ironOre = 'ironOre',
  palladium = 'palladium',
  platina = 'platina',
  platinaOre = 'platinaOre',
  rhodium = 'rhodium',
  silver = 'silver',
  silverOre = 'silverOre',
  wood = 'wood',
  hammer = 'hammer',
  nail = 'nail',
  heatinglog = 'heatinglog',
  woodenPlank = 'woodenPlank',
  blackPearl = 'blackPearl',
  earrings = 'earrings',
  necklaces = 'necklaces',
  rings = 'rings',
  ships = 'ships',
  palms = 'palms',
  chairs = 'chairs',
  acorn = 'acorn',
  shiningMetalite = 'shiningMetalite',
  crystallineOre = 'crystallineOre',
  jewelryBoxes = 'jewelryBoxes',
  barrelsOfRum = 'barrelsOfRum',
  pickaxe = 'pickaxe',
  shovel = 'shovel',
  saw = 'saw',
  bed = 'bed',
  table = 'table',
  broom = 'broom',
  leaf = 'leaf',
  metalJoin = 'metalJoin',
  woodenHuts = 'woodenHuts',
  glass = 'glass',
  brick = 'brick',
  clay = 'clay',
  sand = 'sand',
  roofTile = 'roofTile',
  floorTile = 'floorTile',
  brickHuts = 'brickHuts',
  tiledBrickHuts = 'tiledBrickHuts',
  bottle = 'bottle',
  cup = 'cup',
  axe = 'axe',
  rope = 'rope',
  torch = 'torch',
  resin = 'resin',
  mushroom = 'mushroom',
  root = 'root',
  flower = 'flower',
  redWood = 'redWood',
  mineral = 'mineral',
  bug = 'bug',
  bat = 'bat',
  deadWater = 'deadWater',
  bone = 'bone',
  potion = 'potion',
  antidote = 'antidote',

  seasonPoints = 'seasonPoints'
}

export enum StableCoinTokens {
  usdt = 'usdt'
}

export enum TokenUniquenessType {
  Common = 'common',
  Uncommon = 'uncommon',
  Rare = 'rare'
}

export type MiningsTableRow = {
  amount: PaymentCurrencyAmount;
  createdAt: string;
  available: string;
};

export type ExtraReward = {
  label: string;
  media: string;
  tokenName?: Tokens;
};

export type TTokensConfigItem = {
  name: Record<string, string>;
  media: string;
  label: string;
  methodName: string;
  extraReward?: ExtraReward;
  rate?: number;
  interface: 'erc20' | 'erc721';
};

export type TTokensConfig = Record<Tokens | 'usdt', TTokensConfigItem>;

export const tokensConfig: TTokensConfig = {
  usdt: {
    name: {
      contract: 'usdt'
    },
    methodName: 'USDT',
    label: 'usdt',
    media: '/img/icons/usdt.svg',
    interface: 'erc20'
  },
  [Tokens.doubloon]: {
    name: {
      contract: 'doubloon'
    },
    methodName: 'DOUBLOON',
    label: 'doubloon',
    media: '/img/tokens/doubloon.png',
    interface: 'erc20'
  },
  [Tokens.pearl]: {
    name: {
      contract: Tokens.pearl,
      store: 'pearlStore',
      yield: 'pearlYield'
    },
    methodName: 'Pearl',
    label: 'corePearl',
    media: '/img/tokens/pearl.png',
    extraReward: {
      label: 'coreBlackPearl',
      media: '/img/tokens/blackPearl.svg',
      tokenName: Tokens.blackPearl
    },
    interface: 'erc20'
  },
  [Tokens.gold]: {
    name: {
      contract: 'gold',
      yield: 'goldYield'
    },
    label: 'coreGold',
    methodName: 'Gold',
    media: '/img/tokens/gold.png',
    interface: 'erc20'
  },
  [Tokens.goldOre]: {
    name: {
      contract: 'goldOre'
    },
    rate: 0.5,
    label: 'coreGoldOre',
    methodName: 'Gold Ore',
    media: '/img/tokens/goldOre.png',
    extraReward: {
      label: 'coreShiningMetallite',
      media: '/img/tokens/shining_metallite.png',
      tokenName: Tokens.shiningMetalite
    },
    interface: 'erc20'
  },
  [Tokens.coal]: {
    name: {
      contract: 'coal'
    },
    rate: 0.001,
    label: 'coreCoal',
    methodName: 'Coal',
    media: '/img/tokens/coal.png',
    extraReward: {
      label: 'coreCrystallineOre',
      media: '/img/tokens/crystalline_ore.png'
    },
    interface: 'erc20'
  },
  [Tokens.iron]: {
    name: {
      contract: 'iron'
    },
    label: 'coreIron',
    methodName: 'Iron',
    media: '/img/tokens/iron.png',
    interface: 'erc20'
  },
  [Tokens.ironOre]: {
    name: {
      contract: 'ironOre'
    },
    rate: 0.015,
    extraReward: {
      label: 'coreShiningMetallite',
      media: '/img/tokens/shining_metallite.png'
    },
    label: 'coreIronOre',
    methodName: 'Iron Ore',
    media: '/img/tokens/ironOre.png',
    interface: 'erc20'
  },
  [Tokens.shiningMetalite]: {
    name: {
      contract: 'shiningMetalite'
    },
    label: 'coreShiningMetallite',
    methodName: 'Shining Metallite',
    media: '/img/tokens/shining_metallite.png',
    interface: 'erc20'
  },
  [Tokens.crystallineOre]: {
    name: {
      contract: 'crystallineOre'
    },
    label: 'coreCrystallineOre',
    methodName: 'Crystallite Ore',
    media: '/img/tokens/crystalline_ore.png',
    interface: 'erc20'
  },
  [Tokens.palladium]: {
    name: {
      contract: 'palladium'
    },
    label: 'corePalladium',
    methodName: 'Palladium',
    media: '/img/tokens/palladium.png',
    interface: 'erc20'
  },
  [Tokens.platina]: {
    name: {
      contract: 'platina'
    },
    label: 'corePlatina',
    methodName: 'Platina',
    media: '/img/tokens/platina.png',
    interface: 'erc20'
  },
  [Tokens.platinaOre]: {
    name: {
      contract: 'platinaOre'
    },
    label: 'corePlatinaOre',
    methodName: 'Platina Ore',
    media: '/img/tokens/platinaOre.png',
    interface: 'erc20'
  },
  [Tokens.rhodium]: {
    name: {
      contract: 'rhodium'
    },
    label: 'coreRhodium',
    methodName: 'Rhodium',
    media: '/img/tokens/rhodium.png',
    interface: 'erc20'
  },
  [Tokens.silver]: {
    name: {
      contract: 'silver'
    },
    label: 'coreSilver',
    methodName: 'Silver',
    media: '/img/tokens/silver.png',
    interface: 'erc20'
  },
  [Tokens.silverOre]: {
    name: {
      contract: 'silverOre'
    },
    label: 'coreSilverOre',
    methodName: 'Silver Ore',
    media: '/img/tokens/silverOre.png',
    interface: 'erc20'
  },
  [Tokens.wood]: {
    name: {
      contract: 'wood'
    },
    extraReward: {
      label: 'coreAcorns',
      media: '/img/tokens/acorn.png'
    },

    rate: 0.005,
    label: 'coreWood',
    methodName: 'Wood',
    media: '/img/tokens/wood.png',
    interface: 'erc20'
  },
  [Tokens.woodenPlank]: {
    name: {
      contract: 'woodenPlank'
    },
    label: 'coreWoodenPlank',
    methodName: 'Wooden Plank',
    media: '/img/tokens/woodenPlank.png',
    interface: 'erc20'
  },
  [Tokens.hammer]: {
    name: {
      contract: 'hammer'
    },
    label: 'coreSimpleHammer',
    methodName: 'Hammer',
    media: '',
    interface: 'erc20'
  },
  [Tokens.acorn]: {
    name: {
      contract: 'acorn'
    },
    label: 'coreAcorns',
    methodName: 'Acorn',
    media: '',
    interface: 'erc20'
  },
  [Tokens.nail]: {
    name: {
      contract: 'nail'
    },
    label: 'coreNails',
    methodName: 'Nails',
    media: '',
    interface: 'erc20'
  },
  [Tokens.heatinglog]: {
    name: {
      contract: 'heatinglog'
    },
    label: 'coreHeatingLogs',
    methodName: 'Heating Log',
    media: '',
    interface: 'erc20'
  },
  [Tokens.blackPearl]: {
    name: {
      contract: 'blackPearl'
    },
    label: 'coreBlackPearl',
    methodName: 'Black Pearl',
    media: '/img/icons/blackPearl.svg',
    interface: 'erc20'
  },
  [Tokens.seasonPoints]: {
    name: {
      contract: 'seasonPoints'
    },
    label: 'seasonPoints',
    methodName: 'Season Points',
    media: tokens.seasonPoints,
    interface: 'erc20'
  },
  [Tokens.pickaxe]: {
    name: {
      contract: Tokens.pickaxe
    },
    label: 'pickaxe',
    methodName: 'Pickaxe',
    media: '',
    interface: 'erc20'
  },
  [Tokens.shovel]: {
    name: {
      contract: Tokens.shovel
    },
    label: 'shovel',
    methodName: 'Shovel',
    media: '',
    interface: 'erc20'
  },
  [Tokens.saw]: {
    name: {
      contract: Tokens.saw
    },
    label: 'saw',
    methodName: 'Saw',
    media: '',
    interface: 'erc20'
  },
  [Tokens.bed]: {
    name: {
      contract: Tokens.bed
    },
    label: 'bed',
    methodName: 'Bed',
    media: '',
    interface: 'erc20'
  },
  [Tokens.table]: {
    name: {
      contract: Tokens.table
    },
    label: 'table',
    methodName: 'Table',
    media: '',
    interface: 'erc20'
  },
  [Tokens.broom]: {
    name: {
      contract: Tokens.broom
    },
    label: 'coreBroom',
    methodName: 'Broom',
    media: '',
    interface: 'erc20'
  },
  [Tokens.leaf]: {
    name: {
      contract: Tokens.leaf
    },
    label: 'coreLeave',
    methodName: 'Leaves',
    media: '',
    interface: 'erc20'
  },
  [Tokens.metalJoin]: {
    name: {
      contract: Tokens.metalJoin
    },
    label: 'coreMetalJoin',
    methodName: 'Metal Join',
    media: '',
    interface: 'erc20'
  },
  [Tokens.glass]: {
    name: {
      contract: Tokens.glass
    },
    label: 'coreGlass',
    methodName: 'Glass',
    media: '',
    interface: 'erc20'
  },
  [Tokens.brick]: {
    name: {
      contract: Tokens.brick
    },
    label: 'coreBrick',
    methodName: 'Brick',
    media: '',
    interface: 'erc20'
  },
  [Tokens.clay]: {
    name: {
      contract: Tokens.clay
    },
    extraReward: {
      label: 'coreGoldOre',
      media: '/img/tokens/goldOre.png'
    },
    rate: 0.0035,
    label: 'coreClay',
    methodName: 'Clay',
    media: '',
    interface: 'erc20'
  },
  [Tokens.sand]: {
    name: {
      contract: Tokens.sand
    },
    extraReward: {
      label: 'coreSand',
      media: '/img/tokens/sand.png'
    },
    rate: 0.0001,
    label: 'coreSand',
    methodName: 'Sand',
    media: '',
    interface: 'erc20'
  },
  [Tokens.roofTile]: {
    name: {
      contract: Tokens.roofTile
    },
    label: 'coreRoofTile',
    methodName: 'Roof Tile',
    media: '',
    interface: 'erc20'
  },
  [Tokens.floorTile]: {
    name: {
      contract: Tokens.floorTile
    },
    label: 'coreFloorTile',
    methodName: 'Floor Tile',
    media: '',
    interface: 'erc20'
  },
  [Tokens.bottle]: {
    name: {
      contract: Tokens.bottle
    },
    label: 'coreBottle',
    methodName: 'Bottle',
    media: '',
    interface: 'erc20'
  },
  [Tokens.cup]: {
    name: {
      contract: Tokens.cup
    },
    label: 'coreCup',
    methodName: 'Cup',
    media: '',
    interface: 'erc20'
  },
  [Tokens.earrings]: {
    name: {
      contract: 'earrings'
    },
    label: 'coreEarrings',
    methodName: 'Earrings',
    media: '',
    interface: 'erc721'
  },
  [Tokens.necklaces]: {
    name: {
      contract: 'necklaces'
    },
    label: 'coreNecklaces',
    methodName: 'Necklace',
    media: '',
    interface: 'erc721'
  },
  [Tokens.rings]: {
    name: {
      contract: 'rings'
    },
    label: 'coreRings',
    methodName: 'Ring',
    media: '',
    interface: 'erc721'
  },
  [Tokens.ships]: {
    name: {
      contract: 'ships'
    },
    label: 'nftChristmasShip',
    methodName: 'Ships',
    media: '',
    interface: 'erc721'
  },
  [Tokens.palms]: {
    name: {
      contract: 'palms'
    },
    label: 'nftChristmasPalm',
    methodName: 'Palms',
    media: '',
    interface: 'erc721'
  },

  [Tokens.chairs]: {
    name: {
      contract: 'chairs'
    },
    label: 'nftChair',
    methodName: 'Chair',
    media: '',
    interface: 'erc721'
  },

  [Tokens.jewelryBoxes]: {
    name: {
      contract: 'jewelryBoxes'
    },
    label: 'craftingRecipeJewelryBox2',
    methodName: 'Jewelry Boxes',
    media: '',
    interface: 'erc721'
  },

  [Tokens.barrelsOfRum]: {
    name: {
      contract: 'barrelsOfRum'
    },
    label: 'craftingRecipeBarrelOfRum1',
    methodName: 'Barrels of Rum',
    media: '',
    interface: 'erc721'
  },

  [Tokens.woodenHuts]: {
    name: {
      contract: 'woodenHuts'
    },
    label: 'nftHut',
    methodName: 'Wooden Hut',
    media: '',
    interface: 'erc721'
  },
  [Tokens.brickHuts]: {
    name: {
      contract: 'brickHuts'
    },
    label: 'nftBrickHut',
    methodName: 'Brick Hut',
    media: '',
    interface: 'erc721'
  },
  [Tokens.tiledBrickHuts]: {
    name: {
      contract: 'tiledBrickHuts'
    },
    label: 'nftTiledBrickHut',
    methodName: 'Tiled Brick Hut',
    media: '',
    interface: 'erc721'
  },
  [Tokens.axe]: {
    name: {
      contract: Tokens.axe
    },
    label: 'coreAxe',
    methodName: 'Axe',
    media: '/img/tokens/axe.png',
    interface: 'erc20'
  },
  [Tokens.rope]: {
    name: {
      contract: Tokens.rope
    },
    label: 'coreRope',
    methodName: 'Rope',
    media: '/img/tokens/rope.png',
    interface: 'erc20'
  },
  [Tokens.torch]: {
    name: {
      contract: Tokens.torch
    },
    label: 'coreTorch',
    methodName: 'Torch',
    media: '/img/tokens/torch.png',
    interface: 'erc20'
  },
  [Tokens.resin]: {
    name: {
      contract: Tokens.resin
    },
    label: 'coreResin',
    methodName: 'Resin',
    media: '/img/tokens/resin.png',
    interface: 'erc20'
  },
  [Tokens.mushroom]: {
    name: {
      contract: Tokens.mushroom
    },
    label: 'coreMushroom',
    methodName: 'Mushroom',
    media: '/img/tokens/mushrooms.png',
    interface: 'erc20'
  },
  [Tokens.root]: {
    name: {
      contract: Tokens.root
    },
    label: 'coreRoot',
    methodName: 'Root',
    media: '/img/tokens/roots.png',
    interface: 'erc20'
  },
  [Tokens.flower]: {
    name: {
      contract: Tokens.flower
    },
    label: 'coreFlower',
    methodName: 'Flower',
    media: '/img/tokens/fragrantFlowers.png',
    interface: 'erc20'
  },
  [Tokens.redWood]: {
    name: {
      contract: Tokens.redWood
    },
    label: 'coreRedWood',
    methodName: 'Red Wood',
    media: '/img/tokens/redwood.png',
    interface: 'erc20'
  },
  [Tokens.mineral]: {
    name: {
      contract: Tokens.mineral
    },
    label: 'coreMineral',
    methodName: 'Mineral',
    media: '/img/tokens/minerals.png',
    interface: 'erc20'
  },
  [Tokens.bug]: {
    name: {
      contract: Tokens.bug
    },
    label: 'coreBug',
    methodName: 'Bug',
    media: '/img/tokens/bugs.png',
    interface: 'erc20'
  },
  [Tokens.bat]: {
    name: {
      contract: Tokens.bat
    },
    label: 'coreBat',
    methodName: 'Bat',
    media: '/img/tokens/bat.png',
    interface: 'erc20'
  },
  [Tokens.deadWater]: {
    name: {
      contract: Tokens.deadWater
    },
    label: 'coreDeadWater',
    methodName: 'Dead Water',
    media: '/img/tokens/deadWater.png',
    interface: 'erc20'
  },
  [Tokens.bone]: {
    name: {
      contract: Tokens.bone
    },
    label: 'coreBone',
    methodName: 'Bone',
    media: '/img/tokens/bones.png',
    interface: 'erc20'
  },
  [Tokens.potion]: {
    name: {
      contract: Tokens.potion
    },
    label: 'corePotion',
    methodName: 'Potion',
    media: '/img/tokens/potion.png',
    interface: 'erc20'
  },
  [Tokens.antidote]: {
    name: {
      contract: Tokens.antidote
    },
    label: 'coreAntidote',
    methodName: 'Antidote',
    media: '/img/tokens/antidote.png',
    interface: 'erc20'
  }
};

export const exchnageTokenRate = (env: string) =>
  ({
    local: {
      [getAddress('0xCFf7EBE83c1d0571414275bE8F0d56AAe1802c88')]: 0.01,
      [getAddress('0xc0F362B388F3B07e36b2F22BDB41f1322a9B51a8')]: 0.001,
      [getAddress('0x04a4A0842F78c3E6F4f8EBF52506d82fe7819248')]: 0.5,
      [getAddress('0x59aaF881115996a8aECB66cCC1E4c7D19ba29564')]: 0.2,
      [getAddress('0xBf6659A2f65d90962c5613a08DfF7025ACb371Db')]: 0.005,
      [getAddress('0xA027942E2ca3749e28286468D737635b27D7516B')]: 0.015,
      [getAddress('0xD38B113298DE2E33589a88F79e59e1a6d7f94822')]: 0.08,
      [getAddress('0x6A9BB209358Ea1e398A8ab858974DFb5640D3804')]: 0.26,
      [getAddress('0x13ceE6A8F9cAEC421571A97b6bc1c7Dba64fD2aA')]: 0.0001,
      [getAddress('0x4dBe335287d6efC009354Cc884D13843F9C358D8')]: 0.0035
    },
    test: {
      [getAddress('0xCFf7EBE83c1d0571414275bE8F0d56AAe1802c88')]: 0.01,
      [getAddress('0xc0F362B388F3B07e36b2F22BDB41f1322a9B51a8')]: 0.001,
      [getAddress('0x04a4A0842F78c3E6F4f8EBF52506d82fe7819248')]: 0.5,
      [getAddress('0x59aaF881115996a8aECB66cCC1E4c7D19ba29564')]: 0.2,
      [getAddress('0xBf6659A2f65d90962c5613a08DfF7025ACb371Db')]: 0.005,
      [getAddress('0xA027942E2ca3749e28286468D737635b27D7516B')]: 0.015,
      [getAddress('0xD38B113298DE2E33589a88F79e59e1a6d7f94822')]: 0.08,
      [getAddress('0x6A9BB209358Ea1e398A8ab858974DFb5640D3804')]: 0.26,
      [getAddress('0x13ceE6A8F9cAEC421571A97b6bc1c7Dba64fD2aA')]: 0.0001,
      [getAddress('0x4dBe335287d6efC009354Cc884D13843F9C358D8')]: 0.0035
    },
    prod: {
      [getAddress('0x1a08Fecd9ca213F518E8296eFa31d3B33D54B099')]: 0.01,
      [getAddress('0x40037b7503EE21ffA7747dFDdEDcb89805c9273e')]: 0.001,
      [getAddress('0xaa398A4dEB3FB9d208388C10aB89C82c6Cb4bda4')]: 0.5,
      [getAddress('0x614F4363D2b03286Fd7D72657D4a34969362947F')]: 0.2,
      [getAddress('0x414Ef9A63a05e6997a9e95e7043Ee0FDc6D5119f')]: 0.005,
      [getAddress('0x26C97005Af332F0D8f6ca30451195E14fbDd8D41')]: 0.015,
      [getAddress('0x37CC60790a649820752973FA661fef9badaDDeE1')]: 0.08,
      [getAddress('0xaA8c73B042951f4488fAB4b909347ef3feaE5bcC')]: 0.26,
      [getAddress('0xEE4B91DcCa8521c549db0A2d33607869d187414f')]: 0.0001,
      [getAddress('0xE9456F10bfbff68D50F842056C108894067D9a4e')]: 0.0035
    }
  })[env] as Record<string, number>;
